import * as React from "react";
import { CommonHelper, Dictionary } from "../../../react-core/Helpers/CommonHelper";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";
import { SelectEditorFactory } from "../../../react-core/Html/Factories/SelectEditorFactory";
import { AreaGroupType } from "../../../Wrap/Constants/Enums/Domain/AreaGroupType";
import { AreaGroupModel } from "../../../Wrap/Models/Models/PortfolioAnalysis/Investment/AreaGroupModel";
import { AreaGroupTypeMap } from "../Components/Clients/PortfolioDashboard/Components/Insights/Resource/Contents";
import { InsightsStore } from "../Components/Clients/PortfolioDashboard/Components/Insights/Store/Variable";

interface IRegionViewSelectProps extends React.Props<RegionViewSelect> {
    isShowAll: boolean;
    selected: string;
    onChange: (val: string) => void;
}

interface IRegionViewSelectState {
    value: string;
}

export class RegionViewSelect extends BaseComponent<IRegionViewSelectProps, IRegionViewSelectState> {
    constructor(props: IRegionViewSelectProps) {
        super(props);
        this.state = {
            value: this.props.selected,
        };
    }

    private getAccoutviewDictionays(val: Array<AreaGroupModel>): Dictionary[] {
        const options: Dictionary[] = [];
        const { isShowAll } = this.props;

        if (isShowAll) {
            options.push({ key: AreaGroupTypeMap[AreaGroupType.ALL], value: "All" });
        }

        if (val) {
            val.map((item) => {
                options.push({ key: item.Code, value: item.DisplayName });
            });
        }
        return options;
    }

    public render(): JSX.Element {
        const { value } = this.state;
        const { isShowAll } = this.props;

        const RegionViewSelect = SelectEditorFactory.create<string>();
        const regionGroup = InsightsStore.getRegionGroup();
        const _options = [];

        if (regionGroup) {
            if (isShowAll) {
                _options.push(AreaGroupTypeMap[AreaGroupType.ALL]);
            }
            regionGroup.map((item) => {
                _options.push(item.Code);
            });
        }

        const dictionays = regionGroup ? this.getAccoutviewDictionays(regionGroup) : [];

        return (
            <RegionViewSelect
                key="AreaGroupModelView"
                label="Filter"
                selected={value}
                options={_options}
                getText={(x) => CommonHelper.getOptionsTxt(x, dictionays)}
                onChange={(val) => this.props.onChange(val)}
            />
        );
    }
}
